<template>
  <q-btn-dropdown ref="dropdown" size="sm" color="tertiary" v-bind="$attrs">
    <Grid class="q-pa-md" :style="{ width: menuWidth }">
      <slot />

      <q-btn
        :disable="disableBtn"
        :loading="loadingBtn"
        color="positive"
        class="q-mt-md update-btn"
        @click="$emit('update')"
      >
        Update
      </q-btn>
    </Grid>
  </q-btn-dropdown>
</template>

<script>
export default {
  props: {
    disableBtn: Boolean,
    loadingBtn: Boolean,
    menuWidth: {
      type: String,
      default: '300px'
    }
  },

  methods: {
    // access from parent
    hide() {
      this.$refs.dropdown.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.update-btn {
  justify-self: right;
}
</style>
